import React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import FormControl from "@mui/material/FormControl";
import { COLLECTION_SYNC_MODES } from "../utils/collection";
const LABELS = { never: "Never", ask: "Always ask", always: "Always" };
const COLORS = {
  never: "var(--color-sync-never)",
  ask: "var(--color-sync-ask)",
  always: "var(--color-sync-always)",
};
export default function CollectionSyncSwitch({ value, onChange, disabled }) {
  return (
    <FormControl disabled={disabled} fullWidth sx={{ my: 2 }}>
      <ToggleButtonGroup
        className="collection-sync-switch"
        data-value={value}
        exclusive
        fullWidth
        value={value}
        disabled={disabled}
        aria-label="Sync collection changes with Discogs"
        onChange={(_, next) => {
          if (next) onChange(next);
        }}
        onKeyDown={(event) => {
          if (disabled) return;
          const index = COLLECTION_SYNC_MODES.indexOf(value);
          const next = {
            ArrowLeft: (index + 2) % 3,
            ArrowUp: (index + 2) % 3,
            ArrowRight: (index + 1) % 3,
            ArrowDown: (index + 1) % 3,
            Home: 0,
            End: 2,
          }[event.key];
          if (next !== undefined) {
            event.preventDefault();
            onChange(COLLECTION_SYNC_MODES[next]);
            event.currentTarget.querySelectorAll("button")[next].focus();
          }
        }}
      >
        {COLLECTION_SYNC_MODES.map((mode) => (
          <ToggleButton
            key={mode}
            value={mode}
            tabIndex={value === mode ? 0 : -1}
            sx={{
              borderRadius: 6,
              "&.Mui-selected, &.Mui-selected:hover": {
                bgcolor: COLORS[mode],
                color: "var(--color-white)",
              },
            }}
          >
            {LABELS[mode]}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </FormControl>
  );
}
